import { defineComponent } from "vue";
import SmeLayout from "../../layouts/SmeLayout";
import SmePhoneForm from "../../components/SmePhoneForm";

export default defineComponent({
    components: {
        SmeLayout,
        SmePhoneForm,
    },

    template: `
        <SmeLayout class="StepSmeOtherTariff">
            <div class="SmeSupportFormBox contentbox contentbox--white">
                <h1 class="title-2">Witamy ponownie!</h1>

                <SmePhoneForm type="nip.reservation">
                    <p class="SmeSupportFormBox__text">Wprowadź swój numer telefonu, a nasz Doradca skontaktuje się z Tobą. </p>
                </SmePhoneForm>
            </div>
        </SmeLayout>
    `,

    emits: [
        'offers'
    ],

    props: {
    },

    setup(props, ctx) {
        return {
        };
    },
});
